import React from "react";

import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Card, CardBody } from "reactstrap";

import CircularUploader from "../common/CircularUploader";
import LinearUploader from "../common/LinearUploader";
import CoverCreator from "./CoverCreator";

const PrewiewToken = (props) => {
	const {
		textMaxWidth,
		previewData,
		contractType,
		tempIsUploading,
		filePath,
		fileType,
		fileName,
		cover,
		lockableIsUploading = false,
		openLockableModal,
	} = props;
	return (
		<Card>
			<CardBody>
				<h4>Preview</h4>
				{tempIsUploading ? (
					<Card
						style={{
							display: "flex",
							flexWrap: "wrap",
							justifyContent: "center",
							alignItems: "center",
							width: "100%",
							minHeight: "260px",
							maxHeight: "85vh",
							overflow: "auto",
							borderRadius: "16px",
							padding: "14px",
							margin: "2rem 0",
						}}
					>
						<CircularUploader />
					</Card>
				) : !fileName ? (
					<Card
						style={{
							display: "flex",
							flexWrap: "wrap",
							justifyContent: "center",
							alignItems: "center",
							width: "100%",
							minHeight: "260px",
							maxHeight: "85vh",
							overflow: "auto",
							borderRadius: "16px",
							padding: "14px",
							margin: "2rem 0",
						}}
					>
						<h6 style={{ textAlign: "center" }}>
							Upload file to preview your brand new NFT
						</h6>
					</Card>
				) : (
					<Card
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							width: "100%",
							borderRadius: "4px",
							padding: "0.25rem",
							margin: "0",
						}}
					>
						<CoverCreator
							path={filePath}
							fileType={fileType}
							fileName={fileName}
							cover={cover}
						/>
					</Card>
				)}

				{!!Object.values(previewData).length && (
					<>
						<Paper
							sx={{
								width: "100%",
								p: "1rem",
								m: "0.5rem 0",
							}}
						>
							<Typography
								sx={{
									maxWidth: "226.25px",
									overflowY: "hidden",
									textOverflow: "ellipsis",
								}}
							>{`Name: ${previewData?.name || ""}`}</Typography>
							<Typography
								sx={{
									maxWidth: textMaxWidth,
									overflowY: "hidden",
									textOverflow: "ellipsis",
								}}
							>{`Description: ${
								previewData?.description || "- - -"
							}`}</Typography>
							{contractType === "ERC1155" && (
								<Typography
									sx={{
										maxWidth: textMaxWidth,
										overflowY: "hidden",
										textOverflow: "ellipsis",
									}}
								>{`Amount: ${previewData?.amount || ""}`}</Typography>
							)}
							<Typography
								sx={{
									maxWidth: textMaxWidth,
									overflowY: "hidden",
									textOverflow: "ellipsis",
								}}
							>
								{`Price: ${previewData?.price || ""}`}
							</Typography>
							{!!previewData?.royalties && (
								<Typography
									sx={{
										maxWidth: textMaxWidth,
										overflowY: "hidden",
										textOverflow: "ellipsis",
									}}
								>
									{`Royalties: ${previewData.royalties}`}
								</Typography>
							)}
						</Paper>
						{previewData?.attributes[0].value && (
							<Paper
								sx={{
									width: "100%",
									p: "1rem",
									m: "0.5rem 0",
								}}
							>
								<Typography
									sx={{
										maxWidth: textMaxWidth,
										overflowY: "hidden",
										textOverflow: "ellipsis",
									}}
								>
									Properties:
								</Typography>
								<Box
									component="table"
									className="mt-2 mt-xl-0 w-100"
									sx={{ maxWidth: textMaxWidth }}
								>
									{previewData.attributes.map((item, index) => {
										return (
											<tr key={index}>
												<td>{item.trait_type}</td>
												<td>{item.value}</td>
											</tr>
										);
									})}
								</Box>
							</Paper>
						)}
					</>
				)}

				{previewData?.digitalKey?.type && (
					<Card
						sx={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							width: "100%",
							minHeight: "67px",
							background: "#fbfbfb",
							borderRadius: "16px",
							padding: "35px",
							margin: "2rem 0",
							overflowX: "auto",
						}}
					>
						<Typography component="p" sx={{ padding: "0.5rem" }}>
							Unkockable content
						</Typography>
						{!previewData?.digitalKey.type ? (
							<LinearUploader />
						) : (
							<Typography
								component="p"
								onClick={() => {
									if (previewData.digitalKey.type !== "text")
										openLockableModal(true);
								}}
								sx={{
									width: "100%",
									maxWidth: textMaxWidth,
									margin: "0.5rem 0",
									padding: "0.5rem",
									cursor:
										previewData.digitalKey.type !== "text"
											? "pointer"
											: "default",
								}}
							>
								{previewData.digitalKey.fileName ||
									previewData.digitalKey.value}
							</Typography>
						)}
					</Card>
				)}
			</CardBody>
		</Card>
	);
};

export default PrewiewToken;
